import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { upperCaseFirstLetterOnString } from "../../../SharedComponents/utils/helpers/uppercaseFirstLetterOnString";
import CarImageVisualizer from "../HomePageComponents/CarImageVisualizer";

const PartOfferBody = ({
    partOffer
}) => {

    const car = {
        title: partOffer.PartRequest.UserCar.title,
        Make: partOffer.PartRequest.Make,
        Model: partOffer.PartRequest.Model,
        Motor: partOffer.PartRequest.Motor,
        UserCarImages: partOffer.PartRequest.UserCar.UserCarImages
    };


    const getPriceString = () => {
        const price = partOffer.price.toString();
        const currencyUpCase = partOffer.currency.toUpperCase();

        return `${price} ${currencyUpCase}`;
    };


    const getPartConditionAndWarranty = () => {
        let finalString = "";

        let partCondition = "";

        if (partOffer.type === 'used') {
            partCondition = "Polovan deo"
        };

        if (partOffer.type === 'new') {
            partCondition = "Nov deo"
        };

        finalString = partCondition;

        const guarantee = partOffer.guarantee;

        if (guarantee) {
            finalString += ` ▪ ${guarantee}`;
        };

        return finalString;
    };

    const getAdressAndDeliveryString = () => {
        //Adress is missing on backend right now
        let finalString = "";

        const delivery = partOffer.delivery;

        if (delivery) {
            finalString = upperCaseFirstLetterOnString(delivery);
        };

        return finalString;
    };



    return (
        <div>
            <p style={styles.title}>
                {partOffer.title}
            </p>

            <div style={styles.bodyContainer}>
                <CarImageVisualizer
                    car={car}
                    includeDesc={false}
                />

                <div style={styles.infoContainer}>
                    <p style={styles.title}>
                        {getPriceString()}
                    </p>
                    <p style={styles.subtitle}>
                        {getPartConditionAndWarranty()}
                    </p>
                    <p style={styles.subtitleLight}>
                        {getAdressAndDeliveryString()}
                    </p>
                    <p style={styles.text}>
                        {partOffer.description}
                    </p>
                </div>
            </div>

        </div>
    );
};

export default PartOfferBody;

const styles = {
    bodyContainer: {
        marginTop: 20,
        display: 'flex',
        gap: 20
    },
    infoContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)",
    },
    subtitle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "20px",
        color: "rgba(0, 0, 0, 0.87)",
    },
    subtitleLight: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "20px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    text: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)"
    }
}